import { Box, Button, Container, Grid, Paper, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import { register } from '../../redux/AuthSlice';
import { Link, useNavigate } from 'react-router-dom';

function Registration() {
    const [registrationData, setRegistrationData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        image: null,
    });
    const [error, setError] = useState(null)
    const dispatch = useDispatch();
    const navigation = useNavigate()

    const registerMutation = useMutation({
        mutationFn: (formData) => dispatch(register(formData)),
        onSuccess: (data) => {
            if (data?.payload?.token) {
                navigation("/")
            } else {
                setError(data?.payload)
            }

        },
        onError: (err) => {
            console.log("Error", err);
        },
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('first_name', registrationData.firstName);
        formData.append('last_name', registrationData.lastName);
        formData.append('email', registrationData.email);
        formData.append('password', registrationData.password);
        formData.append('profile_pic', registrationData.image);

        registerMutation.mutate(formData);
    }

    return (
        <Container maxWidth="md">
            <Typography variant='h3' style={{ marginTop: 50, marginBottom: 25, fontWeight: "bold", textAlign: "center" }} sx={{ fontSize: { xs: '26px', sm: '30px', md: '40px' } }}>Register Now</Typography>
            <Box component={Paper} style={{ background: "Whitesmoke", padding: "25px" }}>
                <Box component="form" onSubmit={handleSubmit}>
                    <Grid container spacing={2} style={{ marginTop: 10, alignItems: "center", justifyContent:"center" }}>
                        <Grid item md={6}>

                            <Box
                                component="img"
                                sx={{
                                    width: '100%',
                                    objectFit: 'cover',
                                    borderRadius: 2,
                                }}
                                alt="Example Image"
                                src="assets/image/register.png"
                            />
                        </Grid>
                        <Grid item md={6}>
                            <Grid container spacing={2} style={{ marginTop: 10, }}>
                                <Grid item md={6} xs={12}>
                                    <Typography className="label">First Name</Typography>
                                    <TextField
                                        value={registrationData.firstName}
                                        onChange={(e) => setRegistrationData({ ...registrationData, firstName: e.target.value })}
                                        fullWidth
                                        variant="outlined"
                                        required
                                        style={{ marginBottom: 20 }}
                                    />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <Typography className="label">Last Name</Typography>
                                    <TextField
                                        value={registrationData.lastName}
                                        onChange={(e) => setRegistrationData({ ...registrationData, lastName: e.target.value })}
                                        fullWidth
                                        variant="outlined"
                                        required
                                        style={{ marginBottom: 20 }}
                                    />
                                </Grid>
                            </Grid>
                            <Typography className="label">Email</Typography>
                            <TextField
                                value={registrationData.email}
                                onChange={(e) => setRegistrationData({ ...registrationData, email: e.target.value })}
                                fullWidth
                                variant="outlined"
                                required
                                style={{ marginBottom: 20 }}
                            />
                            <Typography className="label">Password</Typography>
                            <TextField
                                value={registrationData.password}
                                onChange={(e) => setRegistrationData({ ...registrationData, password: e.target.value })}
                                fullWidth
                                type='password'
                                variant="outlined"
                                required
                                style={{ marginBottom: 20 }}
                            />
                            <Typography className="label">Profile Photo</Typography>
                            <TextField
                                fullWidth
                                type='file'
                                onChange={(e) => setRegistrationData({ ...registrationData, image: e.target.files[0] })}
                                accept="image/*"
                                variant="outlined"
                                style={{ marginBottom: 20 }}
                                  inputProps={{ accept: "image/jpeg, image/jpg" }}
                            />
                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                type='submit'
                                disabled={registerMutation.isLoading}
                                sx={{ py: 1.5, mt: 2, fontSize: '16px', fontWeight: 'bold' }}
                            >
                                {registerMutation.isLoading ? 'Registering...' : 'Register Now'}
                            </Button>
                            {error && <Typography style={{ marginTop: 10 }} color="error">{error.message}</Typography>}
                            {registerMutation.isError && <Typography color="error">Registration failed. Please try again.</Typography>}
                            <Typography style={{ textAlign: "center", marginTop: '10px' }} > Already Registered? <Link to='/' style={{ color: "#4CAF50" }}>Login Now</Link></Typography>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Container>
    );
}

export default Registration;
